export const CART_ADD_ITEM = "CART_ADD_ITEM";
export const CART_REMOVE_ITEM = "CART_REMOVE_ITEM";
export const CART_SAVE_PAYMENT_METHOD = "CART_SAVE_PAYMENT_METHOD";
export const FAVOURITES_ADD_ITEM = "FAVOURITES_ADD_ITEM";
export const FAVOURITES_REMOVE_ITEM = "FAVOURITES_REMOVE_ITEM";
export const CART_CLEAR = "CART_CLEAR";
